import React from 'react';
import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import Container from './styles/Container';
import RightWrapper from './styles/RightWrapper';
const Label = styled.div({
    paddingTop: rem(4),
});
const IconWrapper = styled.span({
    marginLeft: rem(8),
});
const BackButtonIcon = styled.div({
    cursor: 'pointer',
    marginRight: rem(8),
    minWidth: rem(32),
});
const ControlsCloseIcon = styled.div({
    cursor: 'pointer',
    marginLeft: rem(8),
});
const Header = ({ children, backButton, closeButton, icons, isDivider, }) => (React.createElement(Container, { isDivider: isDivider },
    backButton && React.createElement(BackButtonIcon, null, backButton),
    React.createElement(Label, null, children),
    React.createElement(RightWrapper, null,
        icons &&
            icons.map((item, index) => (React.createElement(IconWrapper, { key: `hicon-${index}` }, item))),
        closeButton && React.createElement(ControlsCloseIcon, null, closeButton))));
export default Header;
